import { FC } from 'react';
import { AdminUserProfileForm } from 'components/Forms';
import { SecondaryAdminUserProfileForm } from 'components/Forms/SecondaryAdminUserProfileForm';
import { useStore } from 'hooks/useRootStore';
import { EndUserProfileForm } from 'components/Forms/EndUserProfileForm';
import { observer } from 'mobx-react-lite';
// import { EndUserProfile } from 'components/Forms/EndUserProfileForm';
export const AdminUserProfile: FC = observer(() => {
  const {
    userStore: { user },
  } = useStore();
  return (
    <>
      {user && user.permission === 'ClientAdmin' ? <AdminUserProfileForm /> : ''}
      {user && (user.permission === 'SystemAdmin' || user.permission === 'billing_admin') ? (
        <SecondaryAdminUserProfileForm />
      ) : (
        ''
      )}
      {/* {user && (user.permission === 'EndUser' ||  user.permission === 'Manager') ? <EndUserProfile /> : ''} */}
      {user && (user.permission === 'EndUser' || user.permission === 'Manager') ? <EndUserProfileForm /> : ''}
    </>
  );
});
